import { Button } from "components";
import { useBuyingGroupProfileParam } from "./BuyingGroupProfile.hooks";

interface BuyingGroupProfileButtonProps {
  domain: string;
}

export const BuyingGroupProfileButton = ({
  domain,
}: BuyingGroupProfileButtonProps) => {
  const { domain: openedDomain, openBuyingGroupProfile } =
    useBuyingGroupProfileParam();

  return (
    <Button
      variant="link-teal"
      size="sm"
      isActive={openedDomain === domain}
      onClick={() => openBuyingGroupProfile(domain)}
    >
      View Buying Group Profile
    </Button>
  );
};
